import moment from 'moment';
import { createFetchActions } from '../createFetchActions';
import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import {
  GET_ALL_VPIN_PROJECTS,
  GET_ALL_LRS_PROJECTS,
  GET_LRS_PROJECT_PROCEDURES,
  GET_LRS_PROJECT_PROCEDURES_SUCCESS,
  GET_LRS_PROJECT_PROCEDURES_ERROR,
} from './types';

export const actionCreators = {
  getAllVpinProjects: (currentDate, endDate) => {
    const currentDateString = currentDate ? moment(currentDate).format() : '';
    const endDateString = endDate ? moment(endDate).format() : '';
    return createFetchActions({
      startAction: GET_ALL_VPIN_PROJECTS,
      url: `/api/system/vpin?currentDate=${currentDateString}&endDate=${endDateString}`
    })
  },
  getAllLrsProjects: () => (
    createFetchActions({
      startAction: GET_ALL_LRS_PROJECTS,
      url: '/api/system/lrs',
    })
  ),
  getLrsProcedures: (requestNumber, isNewLR = false) => {
    return async (dispatch) => {
      dispatch({ type: GET_LRS_PROJECT_PROCEDURES, requestNumber });
      var headers = await getFetchHeaders();
      var endpointUrl = `/api/system/lrs/${requestNumber}/procedures?` + new URLSearchParams({ isNewLR: isNewLR }).toString();
      return fetch(endpointUrl, {
        method: 'GET',
        headers: headers,
      })
        ?.then(async response => {
          return await getFetchResponseData(response)
        })
        ?.then(procedures => {
          dispatch({
            type: GET_LRS_PROJECT_PROCEDURES_SUCCESS,
            requestNumber,
            procedures
          });
        })
        ?.catch(err => {
          dispatch({ type: GET_LRS_PROJECT_PROCEDURES_ERROR, requestNumber });
          return Promise.reject(err);
        });
    }
  },
};